import { render, staticRenderFns } from "./SingleVideo.vue?vue&type=template&id=b9240d60&scoped=true&"
import script from "./SingleVideo.vue?vue&type=script&lang=js&"
export * from "./SingleVideo.vue?vue&type=script&lang=js&"
import style0 from "./SingleVideo.vue?vue&type=style&index=0&id=b9240d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9240d60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VChip})
